export const VIEW_SINGLE = 'single';
export const VIEW_QUADRANTS = 'quadrants';
export const VIEW_TRIPLE = 'triple';

export const ORIENTATION_CEILING = 'ceiling';
export const ORIENTATION_WALL = 'wall';
export const ORIENTATION_FLOOR = 'floor';